import { OnInit, Component, transition, OnDestroy, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbModal, NgbActiveModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';

import { LoadingService } from '@shared/modules/loading';
import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { ParseObject, Language, FileRef, CustomField } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'edit-custom-field',
  styles: [require('./edit-custom-field.component.scss')],
  template: require('./edit-custom-field.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditCustomFieldComponent implements OnInit {
  @Input()
  public customField: CustomField;

  @Input()
  public lang: string;

  public error: Parse.Error;

  constructor(private activeModal: NgbActiveModal) {
    this.customField = new CustomField();
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit() {

  }

  // ===============================================================================================
  // Public Methods
  // ===============================================================================================

  public onSave() {
    this.activeModal.close(this.customField);
  }

  public onDismiss() {
    this.activeModal.dismiss();
  }

  public onCancel() {
    this.activeModal.dismiss();
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+page/edit-custom-field/edit-custom-field.component.ts